import React from 'react';
import logo from '../assets/logo_small.png'

export default function LogoAndText() {
  return (
    <div className="relative mx-auto h-16 w-40">
        <img src={logo} className="h-full w-full object-cover" alt="Logo" />
        <p className="absolute w-full text-gray-600 font-semibold text-xs text-center">
            People's Smart Bus Service
        </p>
    </div>
  );
}
